'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".LineLogo-module_lineLogo__fk7eu{width:3rem}";
var styles = {"lineLogo":"LineLogo-module_lineLogo__fk7eu"};
styleInject["default"](css_248z, 'ce8014bb-3ab6-48ed-a2bb-3e13bc65c374');

exports["default"] = styles;
